var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Registration Type","horizontal":""}},[_c('b-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.choices),function(choice){return _c('option',{key:choice,domProps:{"value":choice}},[_vm._v(_vm._s(choice))])}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab311b9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Form/Frontend/RegistrationType.vue
// module id = RQ4B
// module chunks = 1